import { useCallback, useMemo } from 'react'
import styled from '@emotion/styled'
import color from '../../constant/colors'
import { mobile, useScreen } from '../../utils/responsive-helper'
import Card from '../../components/common/Card'
import Image from '../../components/common/Image'
import Text from '../../components/common/Text'
import { Tooltip } from 'antd'
import config from '../../config'
import moment from 'moment'

moment.locale('th')

const CustomStyleCard = styled(Card)`
  display: flex;
  position: relative;
  flex-direction: row;
  width: 100%;
  margin-bottom: 24px;
  max-height: 125px;
`

const LayoutImage = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  margin-left: 24px;
  margin-right: 24px;

  .ant-badge-dot {
    top: 8px;
    right: 8px;
  }

  ${mobile} {
    margin-top: 32px;
  }
`

const LayoutContent = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  text-align: left;
  margin-top: 22px;
`

const LayoutBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${mobile} {
    max-width: 150px;
  }
`

const LayoutDate = styled.div`
  margin-right: 24px;
  justify-content: flex-end;

  ${mobile} {
    margin-top: 5px;
  }
`

const CustomStyleImage = styled(Image)`
  border-radius: 50%;
  width: 72px;
  height: 72px;
`

type TipsCardProps = {
  id: number
  imagePath: string
  title: string
  description: string
  date: string
  name: string
  onCardClick: () => void
}

const TipsCard = (props: TipsCardProps) => {
  const { isMobile } = useScreen()
  const { onCardClick, imagePath = '', title, name, date } = props

  return (
    <CustomStyleCard onClick={onCardClick}>
      <LayoutImage>
        <CustomStyleImage src={`${config.apiHost}${imagePath}`} />
      </LayoutImage>
      <LayoutContent>
        <LayoutBody>
          <Text ellipsis maxLine={1} size={20} type="Medium">
            {title}
          </Text>
          <Tooltip title={name}>
            <Text ellipsis maxLine={2} size={16} type="Medium" color={color.LIGHT_GRAY}>
              {name}
            </Text>
          </Tooltip>
        </LayoutBody>
        <LayoutDate>
          {isMobile ? (
            <Text ellipsis maxLine={1} size={16} type="Medium" color={color.LIGHT_GRAY}>
              {
                moment(date).fromNow()
              }
            </Text>
          ) : (
            <Text size={16} type="Medium" color={color.LIGHT_GRAY}>
              {
                moment(date).fromNow()
              }
            </Text>
          )}
        </LayoutDate>
      </LayoutContent>
    </CustomStyleCard>
  )
}

export default TipsCard
